import { render } from "./VModal.vue?vue&type=template&id=2b6dbafb&scoped=true"
import script from "./VModal.vue?vue&type=script&lang=js"
export * from "./VModal.vue?vue&type=script&lang=js"

import "./VModal.vue?vue&type=style&index=0&id=2b6dbafb&scoped=true&lang=css"
import "./VModal.vue?vue&type=style&index=1&id=2b6dbafb&scoped=true&lang=css"

import exportComponent from "D:\\inspemblelcsgn\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b6dbafb"]])

export default __exports__